// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1DYx4","rootCenter":"LoadMoreObserver_rootCenter__2-QF2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2kCXh"};